import { User } from '../data-model/schema/databases/client-security/documents/User';

export const formatUserFullName = (user: User): string =>
  [user.firstName, user.lastName].compact().join(' ');
